import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Scrollbar } from "react-scrollbars-custom";

import { toggleTermsConditionModal } from "@/reducers/clientcommon";

import ModalPopUp from "../common/ModalPopUp";
import { RejectIcon } from "../Icons/RejectIcon";

/**
 * Returns a modal pop-up with terms and conditions data.
 *
 * @return {JSX.Element} A modal pop-up component with terms and conditions data.
 */
const TermsConditionModal = () => {
  const dispatch = useDispatch();
  const { showTermsConditionModal } = useSelector(
    (state) => state.clientCommon,
  );
  /**
   * Function to handle the closing action.
   */
  const handleClose = () => {
    dispatch(toggleTermsConditionModal(false));
  };
  const data = [
    {
      title: "Website",
      content: `Each time you access or use www.applocum.com and/or our mobile device
          application (collectively the "Website"), you are deemed to accept
          these terms and conditions. "we" means AppLocum LTD, and "our" shall
          be construed accordingly. "you" means the person firm company or
          organisation browsing and/or using the Website, and “your" shall be
          construed accordingly. "AppLocum LTD Family" means all companies
          connected with us. A company is connected with us if it is: (i) a
          subsidiary or holding company of us; (ii) controlled by the same
          person(s) who control us or our holding company; (iii) a subsidiary or
          holding company of any company in (i) or (ii) above; or (iv) in the
          same group as any company under (i), (ii) or (iii) above. "subsidiary"
          and "holding company" shall be as defined in section 1159 of the
          Companies Act 2006. The term "control" shall have the same meaning as
          defined in Section 416 of the Income and Corporation Taxes Act 1988.
          Two companies are in the same group if they share the same ultimate
          holding company.`,
    },
    {
      title: "Interruptions and Omissions in Service",
      content: `Whilst we try to ensure that the standard of the Website remains high
          and to maintain the continuity of it, the internet is not an
          inherently stable medium, and errors, omissions, interruptions of
          service and delays may occur at any time. We do not accept any
          liability arising from any such errors, omissions, interruptions or
          delays or any ongoing obligation or responsibility to operate the
          Website (or any particular part of it) or to provide the service
          offered on the Website. We may vary the specification of this site
          from time to time without notice.`,
    },
    {
      title: "Links to other Sites",
      content: `On this site you will be offered automatic links to other sites which
          we hope will be of interest to you. We do not accept any
          responsibility for or liability in respect of the content of those
          sites, the owners of which do not necessarily have any connection,
          commercial or otherwise, with us. Using automatic links to gain access
          to such sites is entirely at your own risk.`,
    },
    {
      title: "Information on this Site",
      content: `Whilst we make every effort to ensure that the information on our
          Website is accurate and complete, some of the information is supplied
          to us by third parties and we are not able to check the accuracy or
          completeness of that information. We do not accept any liability
          arising from any inaccuracy or omission in any of the information on
          our Website or any liability in respect of information on the Website
          supplied by you, any other website user or any other person.`,
    },
    {
      title: "Your Use of this Site",
      content: `You may only use the Website for lawful purposes when seeking
          employment or help with your career, when purchasing training courses
          or when recruiting staff. You must not under any circumstances seek to
          undermine the security of the Website or any information submitted to
          or available through it. In particular, but without limitation, you
          must not seek to access, alter or delete any information to which you
          do not have authorised access, seek to overload the system via
          spamming or flooding, take any action or use any device, routine or
          software to crash, delay, damage or otherwise interfere with the
          operation of the Website or attempt to decipher, disassemble or modify
          any of the software, coding or information comprised in the Website.
          You are solely responsible for any information submitted by you to the
          Website. You are responsible for ensuring that all information
          supplied by you is true, accurate, up-to-date and not misleading or
          likely to mislead or deceive and that it is not discriminatory,
          obscene, offensive, defamatory or otherwise illegal, unlawful or in
          breach of any applicable legislation, regulations, guidelines or codes
          of practice or the copyright, trademark or other intellectual property
          rights of any person in any jurisdiction. You are also responsible for
          ensuring that all information, data and files are free of viruses or
          other routines or engines that may damage or interfere with any system
          or data prior to being submitted to the Website. We reserve the right
          to remove any information supplied by you from the Website at our sole
          discretion, at any time and for any reason without being required to
          give any explanation.`,
    },
    {
      title: "Information Submitted by You",
      content: `We will and/or the AppLocum LTD Family will use information supplied
          by you to aid the recruitment process and associated administrative
          functions as well as to facilitate the purchase of training courses
          made through this website. We will process any data which you provide
          in completing the online registration or application forms and any
          further forms, assessments or personal details which you complete or
          provide to us when using the Website in accordance with relevant data
          protection legislation. We explain more about your personal data in
          our Privacy Policy. Transfer outside the EEA: Personal information
          comprising your CV may be accessed through the AppLocum.com database
          by third parties outside the European Economic Area ("EEA"). This
          could happen for instance if you apply for a vacancy where the
          employer is based outside the EEA.`,
    },
    {
      title: "Terms of Business",
      content: `Recruitment: Each employment assignment or placement arising as a
          result of an introduction made by AppLocum will be subject to our
          standard Terms of Business as they are applicable in the
          circumstances. All prospective employers and clients for whom we
          arrange assignments or placements will be provided with a copy of the
          Terms of Business applicable to them at or following registration.
          Separate terms and conditions also apply to the use of our Recruiter
          site. Training Courses: Any training course purchased through this
          website will be subject to the terms issued by the course providers.`,
    },
    {
      title: "Content Rights",
      content: `The rights in material on the Website are protected by international
          copyright, software and trademark laws and you agree to use the
          Website in a way which does not infringe these rights. You may copy
          material on the Website for your own private or domestic purposes, but
          no copying for any commercial or business use is permitted.`,
    },
    {
      title: "Security and Passwords",
      content: `In order to register with the Website and to sign in when you visit
          the Website, you will need to use a username and password. You are
          solely responsible for the security and proper use of your password,
          which should be kept confidential at all times and not disclosed to
          any other person. You must notify us immediately if you believe that
          your password is known to someone else or if it may be used in an
          unauthorised way. We accept no liability for any unauthorised or
          improper use or disclosure of any password.`,
    },
    {
      title: "Termination",
      content: `We may terminate your registration and/or deny you access to the
          Website or any part of it (including any services, goods or
          information available on or through the Website) at any time in our
          absolute discretion and without any explanation or notification.`,
    },
    {
      title: "Liability",
      content: `We accept no liability for any loss (whether direct or indirect, for
          loss of business, revenue or profits, wasted expenditure, corruption
          or destruction of data or for any other indirect or consequential loss
          whatsoever) arising from your use of the Website and we hereby exclude
          any such liability, whether in contract, tort (including for
          negligence) or otherwise. We hereby exclude all representations,
          warranties and conditions relating to the Website and your use of it
          to the maximum extent permitted by law. You agree to indemnify us and
          keep us indemnified against all costs, expenses, claims, losses,
          liabilities or proceedings arising from use or misuse by you of the
          Website. You must notify us immediately if anyone makes or threatens
          to make any claim against you relating to your use of the Website.`,
    },
    {
      title: "Choice of Law and Jurisdiction",
      content: `The use of the Website and any agreements entered into through the
          Website are to be governed by and construed in accordance with English
          law. The courts of England are to have exclusive jurisdiction to
          settle any dispute arising out of or in connection with the use of the
          Website or any agreement made through the Website. Some of the goods
          or services offered through the Website may not be lawful or may
          otherwise not be permitted in certain countries outside the United
          Kingdom. If you attempt to order, receive, purchase or otherwise
          benefit from any such goods or services, we do not accept any
          liability for any losses suffered by you in using the Website which
          you would not have suffered had you been accessing the Website as a
          United Kingdom resident (including as a result of us being prevented
          from dealing with any application or enquiry by any law, regulation or
          other rulings applicable in any country).`,
    },
    {
      title: "Modern Slavery Act statement",
      content: `We are committed to ensuring that there is no modern slavery or human
          trafficking in our supply chains or in any part of our business. For
          our full Modern Slavery Act statement, please <a class="text-primary hover:text-primaryHover" href="https://www.applocum.com/modern-slavery/">click
          here</a>`,
    },
    {
      title: "Changes to Terms and Conditions and Invalidity",
      content: `These terms and conditions may be changed by us at any time. You will
          be deemed to accept the terms and conditions (as amended) when you
          next use the Website following any amendment. If any provision of
          these terms and conditions is held to be invalid by a court of
          competent jurisdiction, such invalidity shall not affect the validity
          of the remaining provisions, which shall remain in full force and
          effect.`,
    },
    {
      title: "Registered Office",
      content: `AppLocum LTD\n Clive House,\n Clive Street,\n Bolton\n BL1 1ET\n Company Number
          10332907. Registered in the UK.`,
    },
  ];
  return (
    <ModalPopUp
      show={showTermsConditionModal}
      maxWidth="sm"
      onClose={() => {
        handleClose();
      }}
      panelClass="max-w-[730px]"
    >
      <div className="grid !max-h-[450px]">
        <div className="sticky top-0 mb-2 flex items-center justify-between bg-white pb-1">
          <h3 className="text-[18px] font-semibold leading-[normal] text-black">
            Terms & Conditions
          </h3>
          <button
            onClick={() => {
              handleClose();
            }}
            className="text-red outline-none ring-0"
          >
            <RejectIcon />
          </button>
        </div>
        <div>
          <Scrollbar style={{ width: "100%", height: 410 }}>
            {data.map((item, index) => (
              <div key={index} className="px-2 pt-2">
                <h4 className="my-2 text-[16px] font-semibold text-primary">
                  {item.title}
                </h4>
                <p
                  className="text-[14px] font-normal leading-[24px] text-black"
                  dangerouslySetInnerHTML={{ __html: item.content }}
                ></p>
              </div>
            ))}
          </Scrollbar>
        </div>
      </div>
    </ModalPopUp>
  );
};

export default TermsConditionModal;
